module.exports = __webpack_public_path__ + "static/media/video.f4c2746d.jpg";